import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import { parse } from 'query-string';
import { AccountForm } from '../components/AccountForm';
import Nav from '../../IDE/components/Header/Nav';
import ErrorModal from '../../IDE/components/ErrorModal';
import { hideErrorModal } from '../../IDE/actions/ide';
import { Overlay } from '../../App/components/Overlay';
import { resetPasswordReset, refreshUser } from '../actions';

export function AccountView() {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(resetPasswordReset());
    // Refresh auth state so a just-verified email reflects here without a manual reload/re-login.
    dispatch(refreshUser());
  }, [dispatch]);
  const location = useLocation();
  const queryParams = parse(location.search);
  const showError = !!queryParams.error;
  const errorType = queryParams.error as string;
  const history = useHistory();

  return (
    <div className="account-settings__container">
      <Helmet>
        <title>{t('AccountView.Title')}</title>
      </Helmet>

      <Nav layout="dashboard" />

      {showError && (
        <Overlay
          title={t('ErrorModal.LinkTitle')}
          ariaLabel={t('ErrorModal.LinkTitle')}
          closeOverlay={() => {
            history.push(location.pathname);
          }}
        >
          <ErrorModal
            type="oauthError"
            service={errorType}
            closeModal={() => dispatch(hideErrorModal())}
          />
        </Overlay>
      )}

      <main className="account-settings">
        <header className="account-settings__header">
          <h1 className="account-settings__title">
            {t('AccountView.Settings')}
          </h1>
        </header>
        <AccountForm />
      </main>
    </div>
  );
}
